import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { App as AntApp, ConfigProvider } from 'antd';
import { getAntdLocale } from 'config/antdLocaleMapper';
import theme from 'config/antdThemeConfig';
import { createAppRouter } from 'routes/routerConfig';

import { AppDispatch } from 'app/store';

import Loader from 'layouts/Suspense';

import GDPRPopup from 'components/GDPRPopup';

import { selectAuthToken } from 'features/auth/authSelectors';
import {
  fetchClientWorkspaceData,
  fetchUserData
} from 'features/auth/authThunks';
import { getClientPaymentMethodsInfo } from 'features/client/clientThunks';
import { selectAppLocale } from 'features/locale/localeSelectors';

import useLoadDictionaries from 'hooks/useLoadDictionaries';

import { CustomRouterFutureConfig } from 'types/route';

const App = (): ReactElement => {
  const dispatch: AppDispatch = useDispatch();
  const token = useSelector(selectAuthToken);
  const locale = useSelector(selectAppLocale);

  useLoadDictionaries();

  useEffect(() => {
    if (token) {
      dispatch(fetchUserData());
      dispatch(fetchClientWorkspaceData());
      dispatch(getClientPaymentMethodsInfo());
    }
  }, [token, dispatch]);

  const router = createAppRouter();

  return (
    <ConfigProvider theme={theme} locale={getAntdLocale(locale)}>
      <AntApp>
        <Loader>
          <RouterProvider
            router={router}
            future={
              {
                v7_startTransition: true,
                v7_relativeSplatPath: true
              } as CustomRouterFutureConfig
            }
          />
        </Loader>
        <GDPRPopup />
        <ToastContainer
          toastClassName="toast"
          position="top-right"
          closeButton={false}
        />
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
